<template>
  <div class="popup-form popup-cloud">
    <div
      class="content-form-popup noselect"
    >
      <div class="header-text">
        <div class="back-button-wrapper pointer" @click="closePopup">
          <img class="nav-link-icon filter-primary" src="@/images/modal-close.svg" alt=""/>
        </div>
        <div class="blackcolor pop-800">
          Nahranie súboru
        </div>
      </div>
      <div>
        <p class="clientError" v-if="fileNameMissing">Zadajte prosím názov súboru</p>
        <p class="clientError" v-if="uploadError">{{ uploadError }}</p>
        <div class="input-group">
          <label for="hodnota-nehnutelnosti" class="field-label"
          >Názov súboru<strong></strong></label
          ><input
          v-model="fileName"
          type="text"
          class="text-input w-input"
          maxlength="128"
          name="hodnota-nehnutelnosti"
          id="hodnota-nehnutelnosti"
          required
        />
        </div>
        <div
          v-for="(fileObject, index) in files"
          :key="index"
        >
          <div class="add-file-wrapper mt-2 p-relative">
            <label
              :for="'file-upload' + index"
              class="sub-ctass image-upload-btn add-file-button pointer blc-color pop-500"
            >
              {{ fileObject?.file?.name ? fileObject.file.name : "Fotka / Sken " + (index + 1) }}
              <img src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f50_icons8-done.svg" class="nav-link-icon extrasmall filter-primary MGleft10px" alt="" v-if="fileObject.file">
              <input @change="handleFiles(index)" :id="'file-upload' + index" type="file" :accept="extra ? extra : '.pdf,.xlsx,.png,.jpg,.jpeg,.docx,.doc,.zip,.asice'"/>
            </label>
            <div
              class="closebtn-broker-app pointer"
              v-if="index > 0"
              @click="files.splice(index, 1)"
            >
            <img class="nav-link-icon extrasmall white" src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f24_icons8-close.svg"/>
            </div>
          </div>
          <div class="input-group" v-if="fileObject.encrypted">
            <label :for="fileObject.file.name" class="field-label">
              Zadajte heslo:
            </label>
            <div class="input-wrapper">
              <input
                type="text"
                class="text-input w-input date-input"
                v-model="fileObject.password"
                :name="fileObject.file.name"
                :id="fileObject.file.name"
              />
              <div class="input-float-button">
                <span class="pop-600 bl-color font-size-12 pointer noselect" @click="submitUnlockPdf(fileObject.password, fileObject.file, index)">
                  Odomoknúť
                </span>
              </div>
            </div>
          </div>
        </div>
        <div
          class="text-cta d-flex center MGtop20px"
          :class="{'locked-add': lockedPassword}"
          @click="addNewFile"
          v-if="!fileWord && !fileZip && !fileExcel && !fileAsice"
        >
          + PRIDAŤ STRANU
        </div>
      </div>
    </div>
    <div class="information-wrapper">
      <span class="blc-color">Dokument môžete nahrať pomocou viacerých fotiek alebo PDF súborov; po uložení sa automaticky zlúčia do jedného. Maximálna veľkosť je 25 MB.</span>
      <div>
        <v-progress-circular
          v-if="loading"
          class="loading-spinner extrasmall"
          indeterminate
        ></v-progress-circular>
        <button
          v-else
          class="w-button"
          :class="{'locked-add': lockedPassword}"
          @click="transformFiles"
        >
          Uložiť a odoslať
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {PDFDocument} from 'pdf-lib';
import Compressor from 'compressorjs';
import ConvertApi from "convertapi-js";
import {getFile} from "@/services/brokerService";

const MAX_UPLOAD_SIZE = 25 * 1024 * 1024;

export default {
  name: "DocumentCloudFileUpload",
  props: {
    type: Number,
    extra: [String, null],
  },
  methods: {
    addNewFile() {
      if (this.lockedPassword) return;
      this.files.push({file: null})
    },
    checkFormLockedPdfs() {
      for (const file of this.files) {
        if (file.encrypted) return true;
      }
      return false;
    },
    async submitUnlockPdf(password, pFile, index) {
      let file = pFile;
      file = await this.unlockPdf(file, password);
      if (!file) {
        this.$store.commit("appState/setSuccessMessage", {
          text: "Zadajte správne heslo dané PDF",
          type: "error"
        });
        return;
      }
      this.$set(this.files, index, {
        encrypted: false,
        password: "",
        file
      });
      this.lockedPassword = this.checkFormLockedPdfs();
    },
    async createPdfFromFiles() {
      const pdfDoc = await PDFDocument.create();
      const sizeOverflow = this.checkFilesSizeOverflow(5000000);

      let size = 0;
      for (const file of this.files) {
        size += file.file.size
      }

      for (let file of this.files) {
        file = file.file
        if (file.type.includes("jpeg") || file.type.includes("jpg")) {
          await this.appendJpeg(file, pdfDoc, sizeOverflow);
        } else if (file.type.includes("pdf")) {
          await this.appendPdf(file, pdfDoc);
        } else if (file.type.includes("png")) {
          await this.appendPng(file, pdfDoc, sizeOverflow);
        }
      }
      const savedPdf = await pdfDoc.save();
      const bytes = new Uint8Array(savedPdf);
      return new Blob([bytes], {type: "application/pdf"});
    },
    async appendPdf(pFile, pdfDoc) {
      const mbMax = 5;
      const sizeLimit = mbMax * 1024 * 1024;

      let file = pFile;
      if (pFile.size > sizeLimit) {
        file = await this.compressPdf(pFile);
      }

      const fileBytes = await file.arrayBuffer();
      const loadedPdf = await PDFDocument.load(fileBytes);
      const pages = loadedPdf.getPageCount();
      const copiedPages = await pdfDoc.copyPages(loadedPdf, Array.from({length: pages}, (_, i) => i));
      copiedPages.forEach(page => pdfDoc.addPage(page));
    },
    async compressPdf(file) {
      let convertApi = ConvertApi.auth('token_pbmcXbr4')
      let params = convertApi.createParams()
      params.add('File', file);
      params.add('Preset', 'ebook');
      const convertResponse = await convertApi.convert('pdf', 'compress', params);
      return await this.retrieveFileFromConvertApi(convertResponse);
    },
    async appendPng(pFile, pdfDoc, sizeOverflow) {
      let file = pFile;
      const page = pdfDoc.addPage();
      if (!sizeOverflow) {
        file = await this.compressFiles(file);
      }
      const fileBytes = await file.arrayBuffer();
      let image;
      if (file.type === "image/jpeg") {
        image = await pdfDoc.embedJpg(fileBytes);
      } else {
        image = await pdfDoc.embedPng(fileBytes);
      }
      this.drawImageIntoPage(page, image);
    },
    async appendJpeg(pFile, pdfDoc, sizeOverflow) {
      let file = pFile;
      const page = pdfDoc.addPage();
      if (!sizeOverflow) {
        file = await this.compressFiles(file);
      }
      const fileBytes = await file.arrayBuffer();
      const image = await pdfDoc.embedJpg(fileBytes);
      this.drawImageIntoPage(page, image);
    },
    drawImageIntoPage(page, image) {
      const pageHeight = page.getHeight();
      const pageWidth = page.getWidth();

      const imgWidth = image.width;
      const imgHeight = image.height;

      const widthScale = pageWidth / imgWidth;
      const heightScale = pageHeight / imgHeight;
      const scale = Math.min(widthScale, heightScale, 1);

      const scaledWidth = imgWidth * scale;
      const scaledHeight = imgHeight * scale;

      const x = (pageWidth - scaledWidth) / 2;
      const y = (pageHeight - scaledHeight) / 2;

      page.drawImage(image, {
        x,
        y,
        width: scaledWidth,
        height: scaledHeight,
      });
    },
    async unlockPdf(file, password="") {
      let convertApi = ConvertApi.auth('token_pbmcXbr4');
      let params = convertApi.createParams();
      params.add('File', file);
      params.add('Password', password);
      let decryptedFileInfo = null;
      try {
        decryptedFileInfo = await convertApi.convert('pdf', 'decrypt', params);
      } catch (e) {
        return null;
      }
      return await this.retrieveFileFromConvertApi(decryptedFileInfo);
    },
    async retrieveFileFromConvertApi(fileInfo) {
      const file = fileInfo.files[0];
      const decryptedFile = (await getFile(file.Url)).data
      const loadedPdf = new File([decryptedFile], file.FileName, {
        type: "application/pdf",
      });

      fetch(file.Url, {
        method: "DELETE",
      })

      return loadedPdf;
    },
    async createFileBlob(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = (event) => {
          const data = event.target.result;
          const blob = new Blob([data], { type: file.type });
          resolve(blob);
        }
        reader.onerror = reject;
      });
    },
    async transformFiles() {
      if (this.lockedPassword) {
        this.$store.commit("appState/setSuccessMessage", {
          text: "Pre uloženie súborov, prosím odomknite všetky nahraté súbory.",
          type: "error"
        });
        return;
      }
      if (!this.fileName) {
        this.fileNameMissing = true;
        return;
      }
      if (!this.files.length || this.files.some((item) => !item.file)) {
        this.uploadError = "Vyberte súbor, ktorý chcete nahrať.";
        return;
      }
      this.loading = true;
      this.fileNameMissing = false;
      this.uploadError = null;
      try {
        let blob = null;
        let fileName = this.fileName;

        if (this.files.length === 1) {
          if (this.filePdf) {
            blob = await this.createPdfFromFiles();
            fileName += ".pdf";
          } else if (this.fileWord) {
            blob = await this.createFileBlob(this.files[0].file);
            fileName += this.files[0].file.type === "application/msword" ? ".doc" : ".docx";
          } else if (this.fileZip) {
            blob = await this.createFileBlob(this.files[0].file);
            fileName += ".zip";
          } else if (this.fileExcel) {
            blob = await this.createFileBlob(this.files[0].file);
            fileName += ".xlsx";
          } else if (this.fileAsice) {
            blob = await this.createFileBlob(this.files[0].file);
            fileName += ".asice";
          }
        } else {
          blob = await this.createPdfFromFiles();
          fileName += ".pdf";
        }

        if (!blob) throw new Error("UNSUPPORTED_FILE");
        if (blob.size > MAX_UPLOAD_SIZE) throw new Error("FILE_TOO_LARGE");

        this.$emit("set-meta", {blob: blob, fileName, cloudId: this.type});
        this.closePopup();
      } catch (error) {
        this.uploadError = error.message === "FILE_TOO_LARGE"
          ? "Výsledný súbor je väčší ako 25 MB. Zmenšite ho alebo rozdeľte na viac dokumentov."
          : "Súbor sa nepodarilo spracovať. Skontrolujte, či nie je poškodený alebo v nepodporovanom formáte.";
      } finally {
        this.loading = false;
      }
    },
    checkFilesSizeOverflow(maxSize) {
      let size = maxSize
      for (const file of this.files) {
        size -= file.file.size
      }
      return size >= 0;
    },
    compressFiles(file) {
      console.log(file.type);
      return new Promise((resolve, reject) => {
        new Compressor(file, {
          quality: 0.2,
          mimeType: 'image/png', // keep PNG format
          convertSize: 0,        // disable JPEG conversion
          success(result) {
            resolve(result);
          },
          error(err) {
            reject(err);
          },
        });
      });
    },
    closePopup () {
      this.$store.commit("popupManagerState/popItemFromPopupOrder");
    },
    checkIfPdfIsEncrypted(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = async () => {
          const files = new Blob([reader.result], {type: 'application/pdf'});
          const pdfText = await files.text();
          const encrypted = pdfText.includes("Encrypt");
          resolve(encrypted);
        };
        reader.onerror = reject;
      })
    },
    // pridané cez GPT kvôli ďalším typom files
   async handleFiles(index) {
      const input = document.getElementById(`file-upload${index}`);
      let file = input?.files?.[0];
      if (!file) return;
      this.uploadError = null;

      const otherFilesSize = this.files.reduce((total, item, itemIndex) => (
        itemIndex === index ? total : total + (item.file?.size || 0)
      ), 0);
      if (file.size > MAX_UPLOAD_SIZE || otherFilesSize + file.size > MAX_UPLOAD_SIZE) {
        this.$set(this.files, index, {file: null});
        input.value = "";
        this.uploadError = "Súbor alebo súčet vybraných súborov presahuje maximálnu veľkosť 25 MB.";
        return;
      }
      const fileName = file.name.toLowerCase();
      const fileExtension = fileName.split('.').pop();

      const wordTypes = [
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/msword"
      ];

      const imageTypes = ["image/jpeg", "image/png"];
      const pdfTypes = ["application/pdf"];
      const zipTypes = ["application/zip", "application/x-zip-compressed"];
      const excelTypes = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"];
      const asiceExtensions = ["asice"]; // <-- tu pridávame detekciu podľa názvu

      // 🔹 WORD
      if (wordTypes.includes(file.type)) {
        if (this.files.length > 1) {
          this.$set(this.files, index, {file: null});
          input.value = "";
          this.uploadError = "Dokument Word je možné nahrať iba samostatne.";
          return;
        } else {
          this.$set(this.files, index, { file });
          this.fileWord = true;
        }

      // 🔹 IMAGE / PDF
      } else if (imageTypes.includes(file.type) || pdfTypes.includes(file.type)) {
        this.filePdf = true;
        let pdfEncrypted = pdfTypes.includes(file.type)
          ? await this.checkIfPdfIsEncrypted(file)
          : false;
        let encryptedPdf = null;
        if (pdfEncrypted) {
          this.lockedPassword = true;
          this.$store.commit("appState/setSuccessMessage", {
            text: "Verifikujeme pre Vás nutnosť zadania hesla pre odomknutie súboru PDF",
            type: "success"
          })
          encryptedPdf = await this.unlockPdf(file);
          if (encryptedPdf) {
            this.lockedPassword = false;
            file = encryptedPdf;
            pdfEncrypted = false;
          }
        }

        this.$set(this.files, index, {
          encrypted: pdfEncrypted,
          password: "",
          file
        });

      // 🔹 ZIP
      } else if (zipTypes.includes(file.type)) {
        this.$set(this.files, index, { file });
        this.fileZip = true;

      // 🔹 EXCEL
      } else if (excelTypes.includes(file.type)) {
        this.$set(this.files, index, { file });
        this.fileExcel = true;

      // 🔹 ASICE (detekované podľa prípony, nie MIME typu)
      } else if (asiceExtensions.includes(fileExtension)) {
        this.$set(this.files, index, { file });
        this.fileAsice = true;

      // 🔹 NEZNÁMY TYP
      } else {
        this.$set(this.files, index, {file: null});
        input.value = "";
        this.uploadError = "Nepodporovaný súbor. Povolené sú PDF, XLSX, JPG/PNG, DOC/DOCX, ZIP a ASiC-E.";
        return;
      }

      // Nastavenie názvu
      if (!this.fileName) {
        const nameParts = file.name.split(".");
        nameParts.pop();
        this.fileName = nameParts.join(".");
      }

    },

  },
  data: () => ({
    files: [
      {
        file: null,
      }
    ],
    loading: false,
    lockedPassword: false,
    fileWord: false,
    filePdf: false,
    fileZip: false,
    fileExcel: false,
    fileAsice: false,
    fileNameMissing: false,
    uploadError: null,
    fileName: null,
  }),
}
</script>

<style lang="scss" scoped>
.input-wrapper {
  width: 100%;
  height: auto;
}

.input-float-button {
  position: absolute;
  display: block;
  top: 30px;
  right: 15px;
}

.locked-add {
  opacity: 0.2;
  cursor: not-allowed;
}

.information-wrapper {
  margin-top: 10px;
  display: flex;
  column-gap: 105px;
  flex-direction: column;
  align-items: center;
}

.information-wrapper * {
  margin-top: 10px;
}

.information-wrapper > span {
  text-align: center;
  font-size: 15px;
}
</style>
